import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "2:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-200-1-mode.png`,
        },
      },
    },
  },
  "2:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-200-2-modes.png`,
        },
      },
    },
  },
};

export default components;
